module.exports = __webpack_public_path__ + "img/instagram.ef6301aa.svg";